// eslint-disable-next-line import/no-cycle
import { course as schemaCourse } from './schemas';
import apiClient from './apiClient';
import CourseDataStore from '../../datastores/CourseDataStore';

class CourseDataStoreGraphQL implements CourseDataStore {
  async getCourses() {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaCourse.getCourses
      });
      const { courses } = response.data?.student || {};
      return courses;
    } catch (error) {
      throw new Error('error courses');
    }
  }

  async getCourseSummary(periodId: string) {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaCourse.getCoursesSumary,
        variables: {
          periodId
        }
      });
      const data = response?.data;
      return data;
    } catch (error) {
      throw new Error('error getCourseSummary');
    }
  }

  async getEnrolledPeriodsByStudent() {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaCourse.getEnrolledPeriodsByStudent
      });
      const data = response?.data;
      return data;
    } catch (error) {
      throw new Error('error getEnrolledPeriodsByStudent');
    }
  }

  async getClassAttendance(period: string, sectionId: string) {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaCourse.getClassAttendance,
        variables: {
          period,
          classNbr: sectionId
        }
      });
      const data = response?.data;
      return data.getClassAttendance;
    } catch (error) {
      throw new Error('error getClassAttendance');
    }
  }

  async progressiveCertificationEnabled(
    acadPlan: string,
    prog: string,
    carrer: string
  ) {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaCourse.progressiveCertificationEnabled,
        variables: { acadPlan, prog, carrer },
        fetchPolicy: 'cache-first'
      });
      const data = response?.data;
      return data.progressiveCertificationEnabled;
    } catch (error) {
      throw new Error('error getClassAttendance');
    }
  }
}

export default CourseDataStoreGraphQL;
